module.exports = __webpack_public_path__ + "087a5a0419e83851d387b6abd0efff50.svg";